(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3HoleScore', {
            templateUrl: 'app/shared/score-posting/hole-score.component.html',
            controller: HoleScoreComponent,
            require: {
                form: '^^form'
            },
            bindings: {
                score: '<'
            }
        });

    var filter = [].filter;

    HoleScoreComponent.$inject = ['$element', '$scope', 'equipmentClubType', 'fairwayHitType', 'mediaState'];
    function HoleScoreComponent($element, $scope, equipmentClubType, fairwayHitType, mediaState) {
        var ctrl = this;

        // Properties
        ctrl.isTotal = false;
        ctrl.golfClubs = Object.values(equipmentClubType.$metadata).map(wrap);
        ctrl.fairwayHitTypes = Object.values(fairwayHitType.$metadata).map(wrap);

        // Methods
        ctrl.$onInit = init;
        ctrl.scoreChange = scoreChange

        ///////////////////////////////////

        function init() {
            $scope.$watch('$ctrl.score.disabled', disabledWatchAction);
            $scope.$watch('$ctrl.score._score.isTrackingStats', isTrackingStatsWatchAction);
            $scope.$watch('$ctrl.score.number', numberWatchAction);
        }

        function scoreChange(e) {
            if (e.target.value > 1 || e.target.value == 0)
                focusNextElement();
        }

        function disabledWatchAction(disabled) {
            disabled ? $element.attr('hidden', 'hidden') : $element.removeAttr('hidden');
        }

        function isTrackingStatsWatchAction(isTrackingStats) {
            $element.toggleClass('hs-tracking-stats', isTrackingStats);
        }

        function numberWatchAction(number) {
            ctrl.type = number === 0 ? 'label' : number % 1 != 0 ? 'total' : 'score';
            $element.removeClass('hs-label hs-1 hs-2 h3 hs-4 hs-5 hs-6 hs-7 hs-8 hs-9 hs-out hs-10 hs-11 hs-12 hs-13 hs-14 hs-15 hs-16 hs-17 hs-18 hs-in hs-tot');
            $element.addClass(number === 0 ? 'hs-label' : number === 9.1 ? 'hs-out' : number === 18.1 ? 'hs-in' : number === 18.2 ? 'hs-tot' : 'hs-' + number);
        }

        function wrap(metadata) {
            return new Wrapper(metadata, mediaState);
        }
    }

    // See: https://stackoverflow.com/questions/7208161/focus-next-element-in-tab-index
    function focusNextElement() {
        var focussableElements = 'input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled])',
            activeElement = document.activeElement,
            form = activeElement && activeElement.form,
            focussable, index, nextElement;

        if (form) {
            focussable = filter.call(form.querySelectorAll(focussableElements), isVisible);
            index = focussable.indexOf(document.activeElement);
            if (index > -1) {
                nextElement = focussable[index + 1] || focussable[0];
                nextElement.focus();
            }
        }

        function isVisible(element) {
            return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
        }
    }



    function Wrapper(metadata, mediaState) {
        this._metadata = metadata;
        this._mediaState = mediaState;
    }
    Object.defineProperties(Wrapper.prototype = {}, {
        name: { get: function () { return this._metadata[this._mediaState.xs ? 'displayName' : 'shortName']; } },
        value: { get: function () { return this._metadata.value } },
    });
})();